import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomalvanncabservice() {



    const cardData = {

keyword: "Pune to Malvan Cab Service",

headingDescription:
    "Rising Cab Service offers safe, comfortable, and reliable Pune to Malvan Cab Service for families, beach lovers, and coastal travelers. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles with experienced chauffeurs for a smooth long-distance journey from Pune to the Konkan coast. Our service includes doorstep pickup, flexible one-way and round-trip options, 24/7 support, and transparent pricing, ensuring a relaxing and scenic travel experience to Malvan’s beaches, forts, and water sports destinations.",

topPlaces: [
    {
        title: "Tarkarli Beach",
        description:
            "Tarkarli Beach is one of the most famous beaches in Maharashtra, known for its crystal-clear water, white sand, and adventure water sports like scuba diving and snorkeling. It is a top destination for marine tourism and attracts travelers looking for both relaxation and adventure on the Konkan coast."
    },
    {
        title: "Sindhudurg Fort",
        description:
            "Sindhudurg Fort is a historic sea fort built by Chhatrapati Shivaji Maharaj located on an island near Malvan. Accessible by boat, it is known for its strong stone architecture, ancient cannons, and panoramic views of the Arabian Sea, making it a major heritage attraction."
    },
    {
        title: "Malvan Beach",
        description:
            "Malvan Beach is a lively coastal destination known for its seafood, water sports, and scenic sunsets. It serves as a gateway to nearby attractions like Sindhudurg Fort and Tarkarli Beach, offering a mix of relaxation and adventure."
    },
    {
        title: "Devbagh Beach",
        description:
            "Devbagh Beach is a peaceful and scenic beach located near the Karli backwaters. It is known for its calm waters, clean shoreline, and beautiful sunset views, making it ideal for relaxation and photography."
    },
    {
        title: "Chivla Beach",
        description:
            "Chivla Beach is a small and quiet beach in Malvan known for its clean surroundings and less crowded atmosphere. It is perfect for travelers seeking peaceful coastal experiences and relaxed evening walks."
    },
    {
        title: "Rock Garden Malvan",
        description:
            "Rock Garden is a scenic coastal viewpoint in Malvan offering rocky shoreline views and sunset photography spots. It is a popular place for evening relaxation and enjoying the natural beauty of the Arabian Sea."
    },
    {
        title: "Vengurla Beaches",
        description:
            "Vengurla is known for its untouched and serene beaches surrounded by coconut groves and hills. Beaches like Sagareshwar and Vengurla Beach offer peaceful escapes for nature lovers and coastal travelers."
    },
    {
        title: "Devgad Fort & Lighthouse",
        description:
            "Devgad Fort is a historic coastal fort offering panoramic sea views along with a nearby lighthouse. The region is also famous for Alphonso mangoes and scenic Konkan landscapes."
    },
    {
        title: "Karli Backwaters",
        description:
            "Karli Backwaters near Malvan offer peaceful boating experiences surrounded by mangroves and calm waters. It is a great place to enjoy nature and relax during a Konkan coastal trip."
    },
    {
        title: "Achara Beach",
        description:
            "Achara Beach is a clean and less commercialized beach near Malvan known for its natural beauty, soft sand, and peaceful environment. It is ideal for long drives and quiet beach experiences."
    }
],



services: [
{
name: "Pune to Malvan Cab Service",
description: "Rising Cab Service offers Pune to Malvan Cab Service for a comfortable Konkan coastal journey. Enjoy well-maintained AC cars including Sedan, SUV, Innova Crysta, and Tempo Traveller with professional drivers, doorstep pickup, flexible stops, and safe long-distance travel ideal for families, groups, and beach holiday travelers."
},
{
name: "Pune to Malvan Taxi Service",
description: "Book Pune to Malvan Taxi Service with Rising Cab Service for a smooth and reliable coastal travel experience. We provide clean vehicles, experienced chauffeurs, transparent pricing, 24x7 support, and comfortable rides suitable for one way and round trip Konkan trips."
},
{
name: "Pune to Malvan Cab Booking",
description: "Rising Cab Service provides easy Pune to Malvan Cab Booking with instant confirmation, multiple vehicle options, and hassle-free travel planning. Ideal for family vacations, beach tours, and weekend getaways with safe and affordable service."
},
{
name: "Pune to Malvan One Way Cab",
description: "Book Pune to Malvan One Way Cab for affordable drop-only travel with flexible pickup timing, comfortable AC vehicles, and professional drivers ensuring a safe and smooth long-distance journey along the Konkan route."
},
{
name: "Pune to Malvan Round Trip Cab",
description: "Our Pune to Malvan Round Trip Cab service is perfect for return travel plans with flexible waiting time, comfortable rides, and budget-friendly packages for families and groups visiting Malvan beaches and forts."
},
{
name: "Pune to Malvan Beach Cab",
description: "Rising Cab Service offers Pune to Malvan Beach Cab for tourists visiting Tarkarli, Chivla Beach, and Sindhudurg Fort. Enjoy scenic coastal drives with clean vehicles, safe drivers, and complete holiday travel support."
},
{
name: "Pune to Malvan Innova Crysta Cab",
description: "Book Pune to Malvan Innova Crysta Cab for premium comfort, spacious seating, and smooth highway driving ideal for long Konkan journeys with family and group travelers seeking luxury and safety."
},
{
name: "Pune to Velas Beach Cab",
description: "Rising Cab Service provides Pune to Velas Beach Cab for visiting the famous Turtle Festival and serene Velas Beach. Enjoy safe, comfortable travel with experienced drivers and flexible pickup options."
},
{
name: "Pune to Velas Taxi Service",
description: "Our Pune to Velas Taxi Service ensures reliable and affordable travel to Velas Beach with clean AC vehicles, professional chauffeurs, and convenient door-to-door service for weekend trips and nature tours."
},
{
name: "Pune to Velas Beach Cab Booking",
description: "Book Pune to Velas Beach Cab Booking instantly with multiple vehicle options, transparent pricing, and 24x7 customer support for a smooth coastal travel experience to the famous turtle nesting site."
},
{
name: "Pune to Velas One Way Cab",
description: "Rising Cab Service offers Pune to Velas One Way Cab for budget-friendly drop services with comfortable vehicles and experienced drivers for safe travel to Velas Beach and nearby attractions."
},
{
name: "Pune to Velas Round Trip Taxi",
description: "Our Pune to Velas Round Trip Taxi service is ideal for same-day or weekend return plans with flexible timing, safe driving, and affordable packages for beach and eco-tourism visitors."
},
{
name: "Pune to Velas Beach Tour Cab",
description: "Rising Cab Service provides Pune to Velas Beach Tour Cab for a complete travel experience including scenic drives, comfortable vehicles, and reliable service for families, photographers, and nature lovers."
},
{
name: "Pune to Velas Beach Innova Cab",
description: "Book Pune to Velas Beach Innova Cab for extra comfort, spacious seating, and smooth travel experience ideal for family trips and group visits to the turtle conservation beach."
},
{
name: "Pune to Velas Beach SUV Taxi",
description: "Rising Cab Service offers Pune to Velas Beach SUV Taxi for a powerful and comfortable ride on coastal roads with professional drivers and safe long-distance travel."
}
],

tableData: [
["Pune to Malvan Cab Service","Pune to Malvan Taxi Service"],
["Pune to Malvan Cab Booking","Pune to Malvan One Way Cab"],
["Pune to Malvan Round Trip Cab","Pune to Malvan Beach Cab"],
["Pune to Malvan Innova Crysta Cab","Pune to Velas Beach Cab"],
["Pune to Velas Taxi Service","Pune to Velas Beach Cab Booking"],
["Pune to Velas One Way Cab","Pune to Velas Round Trip Taxi"],
["Pune to Velas Beach Tour Cab","Pune to Velas Beach Innova Cab"]
],



whychoose: [
    {
        WhyChooseheading: "Reliable Pune to Malvan Cab Service",
        WhyChoosedescription: "Rising Cab Service provides comfortable Pune to Malvan cab transportation for families, tourists, beach lovers, couples, and Konkan vacation travelers."
    },
    {
        WhyChooseheading: "Perfect for Beach Holidays and Konkan Tourism",
        WhyChoosedescription: "Malvan is one of Maharashtra's most popular coastal destinations, known for beautiful beaches, water sports, seafood, and historic attractions."
    },
    {
        WhyChooseheading: "Customized One-Way and Round Trip Packages",
        WhyChoosedescription: "Customers can choose one-way transfers, round-trip journeys, weekend tours, family vacations, and personalized Konkan travel itineraries."
    },
    {
        WhyChooseheading: "Comfortable Vehicles for Every Journey",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to your travel requirements and group size."
    },
    {
        WhyChooseheading: "Explore Famous Attractions Around Malvan",
        WhyChoosedescription: "Travel conveniently to Tarkarli Beach, Sindhudurg Fort, Devbagh Beach, Tsunami Island, Rock Garden, Chivla Beach, and nearby tourist attractions."
    },
    {
        WhyChooseheading: "Doorstep Pickup Across Pune & PCMC",
        WhyChoosedescription: "Pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and surrounding areas."
    },
    {
        WhyChooseheading: "Safe and Scenic Coastal Travel",
        WhyChoosedescription: "Our experienced drivers ensure smooth travel through Konkan highways and coastal routes while providing maximum comfort and safety."
    },
    {
        WhyChooseheading: "Ideal for Families, Couples, and Group Tours",
        WhyChoosedescription: "Rising Cab Service caters to family vacations, honeymoon trips, beach holidays, corporate outings, and Konkan sightseeing tours."
    }
]
};

const faqData = [
    {
        question: "Why is Malvan a popular tourist destination from Pune?",
        answer: "Malvan is famous for its beaches, Sindhudurg Fort, water sports, scuba diving, Konkan cuisine, and beautiful coastal scenery."
    },
    {
        question: "Can I book a one-way cab from Pune to Malvan?",
        answer: "Yes, one-way cab services are available along with round-trip and customized Konkan travel packages."
    },
    {
        question: "Which attractions can be visited during a Malvan trip?",
        answer: "Popular attractions include Tarkarli Beach, Sindhudurg Fort, Devbagh Beach, Tsunami Island, Rock Garden, Chivla Beach, and Malvan Marine Sanctuary."
    },
    {
        question: "Which vehicle is suitable for a family trip to Malvan?",
        answer: "Ertiga and Innova Crysta are among the most preferred options because they provide comfortable seating and sufficient luggage space."
    },
    {
        question: "Do you provide Tempo Travellers for group tours?",
        answer: "Yes, Tempo Travellers and larger vehicles are available for family groups, corporate outings, and Konkan sightseeing tours."
    },
    {
        question: "Can Tarkarli and Malvan be covered in one trip?",
        answer: "Yes, customized itineraries can include Malvan, Tarkarli, Devbagh, Sindhudurg Fort, Kunkeshwar Temple, and nearby coastal attractions."
    },
    {
        question: "Are weekend holiday packages available for Malvan?",
        answer: "Yes, customers can choose weekend beach vacations, overnight stays, and multi-day Konkan holiday packages."
    },
    {
        question: "Can water sports activities be included in the trip?",
        answer: "Yes, visitors can enjoy scuba diving, snorkeling, parasailing, boating, and other water sports at Tarkarli and Devbagh."
    },
    {
        question: "Are pickups available from Pune Airport and Railway Station?",
        answer: "Yes, pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I book a Pune to Malvan Cab Service?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Sandeep Sawant",
        feedback:
            "Our Malvan and Tarkarli vacation was absolutely fantastic. The cab was comfortable, the journey was smooth, and we enjoyed every destination without worrying about transportation.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Priya Naik",
        feedback:
            "The Konkan tour covering Malvan, Devbagh, and Sindhudurg Fort was perfectly organized. The vehicle was spacious, and the travel experience was memorable from start to finish.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Malvan Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-malvan-cab.jpg",
"description": "Book Pune to Malvan Cab Service with Rising Cab Service for safe and comfortable Konkan coastal travel. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars for beach holidays and family trips.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-malvan-cab"
}
};



    return (
        <div>



<Helmet>
  <title>Pune to Malvan Cab Service | Konkan Beach Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Malvan Cab Service for safe and comfortable Konkan coastal travel. Get affordable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars for beach trips and holidays."
/>

<meta
 name="keywords"
 content="pune to malvan cab, pune to malvan taxi, cab from pune to malvan, taxi from pune to malvan, pune to malvan cab service, pune to malvan taxi fare, pune to malvan one way cab, pune to malvan round trip taxi, pune to malvan cab booking, cheap pune to malvan cab, best pune to malvan taxi, konkan malvan cab pune, beach cab pune malvan"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/110.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomalvanncabservice;